import { useSelector } from 'react-redux';
import { videoTranscriptDurationBalanceMillisSelector } from 'redux/modules/pricing';
import useBalance, { UseBalanceOptions } from './useBalance';

export type UseVideoTranscriptDurationBalanceOptions = Omit<
  UseBalanceOptions,
  'balanceMillis'
>;

export default function useVideoTranscriptDurationBalance(
  options: UseVideoTranscriptDurationBalanceOptions = {},
) {
  const balanceMillis = useSelector(
    videoTranscriptDurationBalanceMillisSelector,
  );

  return useBalance({ ...options, balanceMillis });
}
